export const FEATURE_FLAGS = [
  { id: 'weather_news', name: 'WeatherNews連携' },
  { id: 'winter_mode', name: '冬季モード' },
  { id: 'sensor_extract', name: 'センサーデータ抽出' },
  { id: 'digital_signage', name: 'デジタルサイネージ' },
] as const;

export type FeatureFlagId = typeof FEATURE_FLAGS[number]['id'];
